import React, { useEffect, useState } from 'react';
import { hexToRgb } from '@material-ui/core/styles';
import KapinuaColors from '../components/KapinuaColors/KapinuaColors';

interface Props {
    onChangeFuncName: any;
    activeColor: string;
}

declare global {
    interface Window {
        openKapinuaColor: any;
    }
}

export interface IColor {
    hex: string;
    rgb: string;
}

const KapinuaColorsContainer: React.FC<Props> = (props) => {
    const { onChangeFuncName, activeColor } = props;

    const [isOpen, setIsOpen] = useState(false);

    const [externalActiveColor, setExternalActiveColor] = React.useState<
        string | null
    >(null);

    useEffect(() => {
        window.openKapinuaColor = (activeColorHex: string) => {
            setIsOpen(true);
            setExternalActiveColor(activeColorHex);
        };

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnChange = (hex: string) => {
        setIsOpen(false);
        if (
            onChangeFuncName &&
            onChangeFuncName.length > 0 &&
            hex !== null &&
            hex !== undefined
        ) {
            const returnColor = {
                hex: hex,
                rgb: hexToRgb(hex),
            };
            // @ts-ignore
            window[onChangeFuncName](returnColor);
        }
    };

    const handleOnClose = () => {
        setIsOpen(false);
    };

    return (
        <KapinuaColors
            activeColor={activeColor}
            open={isOpen}
            externalActiveColor={externalActiveColor}
            onClose={handleOnClose}
            onChange={handleOnChange}
        />
    );
};

export default KapinuaColorsContainer;
